export default {
  title: "Perfil",
  subtitle: "Gerencie suas informações pessoais e preferências.",
  language: "Idioma",
  languageSuccess: "Idioma atualizado com sucesso",
  languageError: "Falha ao atualizar idioma",
  notSet: "Não definido",
  passwordLabel: "Senha",
  changePassword: "Alterar Senha",
  passwordResetEmailSent: "Email de recuperação de senha enviado com sucesso. Verifique sua caixa de entrada.",
  passwordResetError: "Falha ao solicitar recuperação de senha. Tente novamente mais tarde.",
  emailNotFound: "Email não encontrado. Por favor, atualize seu perfil com um email válido.",
  languages: {
    en: "Inglês",
    pt: "Português"
  },
  avatar: {
    invalidFileType: "Tipo de arquivo inválido",
    invalidFileTypeDescription: "Por favor, envie um arquivo de imagem",
    fileTooLarge: "Arquivo muito grande",
    fileTooLargeDescription: "Por favor, envie uma imagem menor que 5MB",
    updateSuccess: "Foto de perfil atualizada",
    updateSuccessDescription: "Sua foto de perfil foi atualizada com sucesso",
    updateError: "Erro ao atualizar foto de perfil",
    updateErrorDescription: "Falha ao atualizar a foto de perfil",
    remove: "Remover foto",
    removeSuccess: "Foto de perfil removida",
    removeSuccessDescription: "Sua foto de perfil foi removida com sucesso",
    removeErrorDescription: "Falha ao remover a foto de perfil"
  },
  displayName: {
    label: "Nome",
    placeholder: "Digite seu nome",
    updateSuccess: "Perfil atualizado",
    updateSuccessDescription: "Seu nome de exibição foi atualizado com sucesso",
    updateError: "Erro",
    updateErrorDescription: "Falha ao atualizar o nome de exibição"
  },
  position: {
    label: "Função / Cargo",
    placeholder: "Ex.: Gerente de Produto Sênior",
    notSet: "Não definido",
    updateSuccess: "Função atualizada",
    updateSuccessDescription: "Sua função foi atualizada com sucesso",
    updateError: "Erro ao atualizar função",
    updateErrorDescription: "Falha ao atualizar sua função"
  },
  ai: {
    sectionTitle: "Preferências de IA",
    sectionDescription: "Diretrizes pessoais que a IA vai seguir além do contexto do projeto.",
    instructionsLabel: "Instruções pessoais para a IA (Markdown)",
    instructionsPlaceholder: "Exemplo: Responda sempre em português. Sempre mostre um resumo no final de respostas longas...",
    instructionsHint: "Essas instruções são repassadas a qualquer agente de IA via a tool get_my_profile. Aceita Markdown.",
    save: "Salvar",
    cancel: "Cancelar",
    confirmDestructiveLabel: "Pedir confirmação antes de ações destrutivas",
    confirmDestructiveHint: "Quando ligado, os agentes de IA devem pedir confirmação explícita antes de executar tools de update ou delete.",
    updateSuccess: "Preferências de IA atualizadas",
    updateSuccessDescription: "Suas preferências de IA foram salvas.",
    updateError: "Erro ao atualizar preferências de IA",
    updateErrorDescription: "Falha ao salvar suas preferências de IA"
  },
  deleteAccount: {
    title: "Zona de Perigo",
    description: "Ações irreversíveis que afetam permanentemente sua conta.",
    buttonTitle: "Excluir Conta",
    buttonDescription: "Remover permanentemente sua conta e todos os seus dados.",
    deleteButton: "Excluir Minha Conta",
    confirmTitle: "Confirmar Exclusão de Conta",
    confirmDescription: "Esta ação é permanente e não pode ser desfeita. Todos os seus dados serão perdidos.",
    // Para usuários Email/Password
    confirmLabel: "Digite sua senha para confirmar",
    passwordPlaceholder: "Digite sua senha",
    confirmHint: "Insira sua senha atual para confirmar a exclusão da conta.",
    // Para usuários OAuth (Google, Microsoft)
    confirmLabelOAuth: "Digite DELETE para confirmar",
    confirmWordPlaceholder: "DELETE",
    confirmHintOAuth: "Digite DELETE em letras maiúsculas para confirmar a exclusão permanente.",
    confirmButton: "Excluir Permanentemente",
    deleting: "Excluindo...",
    deletingTitle: "Excluindo Conta",
    deletingDescription: "Removendo sua conta e todos os seus dados. Por favor, aguarde...",
    deletingStep: "Processando exclusão",
    deletingMessage: "Removendo todos os seus dados...",
    deletedMessage: "Conta excluída com sucesso",
    success: "Conta excluída com sucesso",
    successDescription: "Sua conta foi removida permanentemente.",
    error: "Erro ao excluir conta",
    errorDescription: "Ocorreu um erro ao excluir sua conta.",
    userNotFound: "Usuário não encontrado",
    passwordRequired: "A senha é obrigatória para confirmar a exclusão",
    confirmWordRequired: "Digite DELETE para confirmar a exclusão",
    incorrectPassword: "Senha incorreta",
    incorrectConfirmWord: "Você deve digitar DELETE para confirmar"
  }
} as const;
